<template>
  <div>
    <!-- Recreational -->
    <hr>
    <p class="lead">
      <strong>How many recreational boats did households own?</strong>
    </p>
    <ChartGrid
      :columns="2"
      :only="chartGrids['recreational']"
    />
    <!-- Households -->
    <hr>
    <ChartGrid
      :columns="1"
      :only="chartGrids['household_overall']"
      class="overall-grid"
    />
    <ChartGrid
      :columns="1"
      :only="chartGrids['household_other']"
    />
  </div>
</template>

<script>
export default {
  name: 'OwnershipPartial',
  props: {
    chartGrids: {
      type: Object,
      required: true
    }
  }
}
</script>
